export default __webpack_public_path__ + "static/media/entity_selector_screenshot.e6bff283.png";